import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { MainPadding } from '../components/MainPadding';

export class NotAllowed extends React.Component<any, any> {
    public render() {
        return (
            <MainPadding>
                <Box
                    sx={{
                        marginTop: 6,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        padding: { xs: 4, md: 7 },
                        borderRadius: '22px',
                        background: 'rgba(255, 255, 255, 0.92)',
                        border: '1px solid rgba(11, 18, 48, 0.06)',
                        boxShadow: '0 1px 2px rgba(11, 18, 48, 0.04), 0 18px 40px -16px rgba(5, 35, 114, 0.18)',
                    }}
                >
                    <Typography className="eyebrow" sx={{ color: 'text.secondary' }}>
                        403 · permission denied
                    </Typography>
                    <Box
                        sx={{
                            mt: 2,
                            width: 72,
                            height: 72,
                            borderRadius: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background:
                                'linear-gradient(180deg, rgba(250, 135, 28, 0.16) 0%, rgba(250, 135, 28, 0.06) 100%)',
                            border: '1px solid rgba(250, 135, 28, 0.32)',
                            color: '#a85b08',
                        }}
                    >
                        <LockOutlined sx={{ fontSize: 32 }} />
                    </Box>
                    <Typography
                        sx={{
                            mt: 3,
                            fontFamily: '"Inter Tight", "Inter", sans-serif',
                            fontWeight: 700,
                            letterSpacing: '-0.022em',
                            fontSize: { xs: 32, md: 42 },
                            lineHeight: 1.05,
                        }}
                    >
                        This area is restricted.
                    </Typography>
                    <Typography sx={{ mt: 1.5, color: 'text.secondary', maxWidth: 480, lineHeight: 1.6 }}>
                        Your account doesn't have permission to view this resource. Reach out to an administrator if you think this is a mistake.
                    </Typography>
                </Box>
            </MainPadding>
        );
    }
}
